export const FETCH_SETTINGS = 'FETCH_SETTINGS';
export const ADD_PARAMS_SETTINGS = 'ADD_PARAMS_SETTINGS';
export const TRANSLATIONS_LABEL_TAG = 'TRANSLATIONS_LABEL_TAG';
export const REMOVE_PARAMS_SETTING = 'REMOVE_PARAMS_SETTING';
